export const menuTitle = { title: "PRODUCT CATEGORY", label: "Product Category" }
  